<template>
  <!--  <div class="home">-->
  <!--    -->
  <!--    <img alt="Vue logo" src="../assets/logo.png">-->
  <!--    <HelloWorld msg="Welcome to Your Vue.js App"/>-->
  <!--  </div>-->
  <div class="login-page">
    <div class="container">
      <h2>登录</h2>

      <form id="loginForm" action="/login" method="post">
        <div class="type-box">
          <div class="user-login" @click="user.type=1" style="border-right: none;" :class="user.type===1?'active':''">
            用户登录
          </div>
          <div class="admin-login" @click="user.type=2" :class="user.type===2?'active':''">管理员登录</div>
        </div>
        <input type="hidden" id="type" name="type" value="1" v-model="user.type">
        <div>
          <label for="username">用户名:</label>
          <input type="text" id="username" name="username" required v-model="user.username">
        </div>
        <div>
          <label for="password">密码:</label>
          <input type="password" id="password" name="password" required v-model="user.password">
        </div>
        <div class="errmsg" style="font-size: 10px;color:red;margin-bottom: 10px; text-align: center;">{{ errmsg }}
        </div>
        <div class="login-box">
          <div style="font-size: 14px;"><input type="radio" checked id="remember"><label for="remember">记住密码</label>
          </div>
          <div><input type="button" id="loginButton" value="登录" @click="login"></div>
        </div>
      </form>
    </div>
    <img class="bg" src="../assets/bg.jpg" alt="">
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'

import request from "@/api/request";

export default {
  name: 'HomeView',
  components: {
    // HelloWorld
  },
  data() {
    return {
      user: {
        username: '',
        password: '',
        type: 1
      },
      errmsg: ''
    }
  },
  mounted() {
    const loginUser = JSON.parse(localStorage.getItem("user"))

    if(loginUser && loginUser.username && loginUser.password) {
      this.user = {...loginUser}
    }
  },
  methods: {
    login() {
      request.post("/login", this.user).then(({data}) => {
        if (data.code === 0) {
          this.errmsg = data.msg;
        } else if (data.code === 200) {
          localStorage.setItem("user", JSON.stringify(data.data));
          this.$store.dispatch("setToken",data.data?.tokenInfo?.tokenValue)
          if (data.data.type === 1){
            this.$router.replace({
              path: 'index'
            })
          }else {
            this.$router.replace({
              path: 'admin'
            })
          }
        }
      })
    }
  }
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: Arial, sans-serif;
  background-color: #f2f2f2;
}

.container {
  position: relative;
  width: 340px;
  padding: 20px;
  background-color: #fff;
  border-radius: 5px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.login-page {
  width: 100vw;
  height: 100vh;
}

.bg {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
}

h2 {
  text-align: center;
  color: #333;
}

label {
  width: 80px;
  display: inline-block;
  margin-bottom: 10px;
  color: #666;
}

input[type="text"],
input[type="password"] {

  padding: 6px;
  width: calc(100% - 90px);
  margin-bottom: 20px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

input[type="button"] {
  width: 100%;
  padding: 8px;
  background-color: #4CAF50;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

input[type="button"]:hover {
  background-color: #45a049;
}

.type-box {
  display: flex;
  height: 30px;
  line-height: 30px;
  margin: 20px 0;
  cursor: pointer;
}

.type-box div {
  flex: 1;
  font-size: 12px;
  border: 1px solid #ccc;
  text-align: center;
}

.active {
  background-color: #719ac9;
  color: #fff;
}

.login-box {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
}

.login-box div {
  text-align: center;
  flex: 1;
}
</style>
